import { RootState } from "store";

export const getIsOpen = (state: RootState) => state.appBar.isOpen;
